/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_UnknownInputs */

const cs_enum_unknown = /** @type {(inputs: Enum_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámý`)
};

const en_enum_unknown = /** @type {(inputs: Enum_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Enum_UnknownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_unknown = /** @type {((inputs?: Enum_UnknownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_UnknownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_unknown(inputs)
	return cs_enum_unknown(inputs)
});